<mat-toolbar [style.background-color]="navbarBgClass()">
  @if (!hideMenuToggle()) {
    <button mat-icon-button (click)="toggle.emit()">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <a [routerLink]="'/home'" (click)="setHomeMenu()">
    <img
      [src]="'../assets/' + clientLogoAsset()"
      id="clientLogo"
      alt="Client logo"
    />
  </a>
  <span class="toolbar-spacer"></span>
  <!-- <a
    mat-button
    class="help-button"
    [style.background-color]="navbarBgClass()"
    [href]="helpUrl()"
    target="_blank"
    rel="noreferrer noopener"
    >Help</a
  > -->

  @if (isLoggedIn()) {
    <p class="snackbar"></p>
    <a
      mat-button
      class="help-button"
      [style.background-color]="navbarBgClass()"
      (click)="logout()"
    >Logout {{loggedInName()}}</a>
  }
</mat-toolbar>
